

export const calculateWidth = () => {
    const mq = window.matchMedia("(min-width: 930px)");
    const run = () => {
        const wrapperTag = document.querySelector('.horizontal-wrapper')
        if (mq.matches) {
            const tags = document.querySelectorAll('.full-width-section, .half-width-section')
            let total = 0
            tags.forEach(tag => {
                if (tag.classList.contains('full-width-and-half-section')) {
                    total += 150
                }
                else if (tag.classList.contains('full-width-section')) {
                    total += 100
                } else if (tag.classList.contains('half-width-section')) {
                    total += 50
                }
            })
            total += 50
            wrapperTag.style.minWidth = `${total}vw`
        } else {
            wrapperTag.style.minWidth = `unset`
        }
    }
    mq.addEventListener('change', () => {
        run()
    })
}

//! Need to update to add a class as it would be more useful
export const calculateImageOrientation = (tag) => {
    const imageTags = document.querySelectorAll(tag)
    imageTags.forEach(imageTag => {
        const img = imageTag.querySelector('img')
        // console.log(img.width, img.height)
        // imageTag.style.flex = `0 1 ${img.width}px`
        // img.width < img.height ? imageTag.classList.add('portrait') : imageTag.classList.add('landscape')   
    })
}


export const rgbToHex = ([r, g, b]) => '#' + [r, g, b].map(x => {
    const hex = x.toString(16)
    return hex.length === 1 ? '0' + hex : hex
}).join('')

